<template>
  <div class="view-container">
    <div class="card">
      <div class="card-header card-header-divider">
        <div class="card-title">FAQ</div>
      </div>
      <div v-if="profile" class="card-body">
        <div v-if="profile === 'admin'">
          Показаны варианты FAQ для всех ролей
        </div>
        <div class="admin-hint" v-if="profile === 'admin'">
          Сотрудник или куратор
        </div>
        <StaffFAQ
          v-if="
            profile === 'staff' || profile === 'curator' || profile === 'admin'
          "
        />
        <div class="admin-hint" v-if="profile === 'admin'">
          Юридическое лицо
        </div>
        <DirectorFAQ v-if="profile === 'director' || profile === 'admin'" />
        <div class="admin-hint" v-if="profile === 'admin'">Физическое лицо</div>
        <PhysicalFAQ
          v-if="profile === 'private_person' || profile === 'admin'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import PhysicalFAQ from "./PhysicalFAQ.vue";
import DirectorFAQ from "./DirectorFAQ.vue";
import StaffFAQ from "./StaffFAQ.vue";

export default {
  components: { PhysicalFAQ, DirectorFAQ, StaffFAQ },
  name: "FAQ",
  setup() {
    const store = useStore();
    const profile = computed(() => store.state.profile.profile?.role);
    return { profile };
  },
};
</script>

<style lang="scss" scoped>
.admin-hint {
  border-bottom: 1px solid var(--main-color);
  border-top: 1px solid var(--main-color);
  padding: 10px;
  margin: 20px 0;
}
</style>
